import React from 'react';
import { useDocumentContext } from '../../../contexts/DocumentContext';
import DocumentCategoryItem from './DocumentCategoryItem';
import SkeletonLoader from './SkeletonLoader';
import styles from '../../../styles/DocumentManagement.module.css';
import { DocumentCategoriesListProps } from '../../../types/DocumentManagement';

// Props interface now imported from types file

const DocumentCategoriesList: React.FC<DocumentCategoriesListProps> = React.memo(({ 
  categoriesWithStats, 
  categoriesMetadata, 
  overallStats, 
  loading,
  error,
  getSubcategoriesForCategory: propGetSubcategoriesForCategory,
  isCompanyMode = false
}) => {
  // Conditionally access the appropriate context based on mode
  const documentContext = useDocumentContext();
  
  // Use appropriate context based on mode
  const selectedUser = isCompanyMode ? null : documentContext.selectedUser;

  if (loading) return <SkeletonLoader variant="categoryList" count={4} />;
  if (error) return <div className={styles.textError}>Error: {error}</div>;

  // Use categoriesWithStats from the new redesigned hook
  const categoriesToRender = categoriesWithStats || [];

  return (
    <div className={styles.documentCategories}>
      <h3 className={styles.categoriesTitle}>📂 Document Categories {selectedUser?.archived ? '(Archived)' : ''}</h3>
      {categoriesToRender.length === 0 && (
        <div className={styles.noDataMessage}>
          No document categories found for this role.
        </div>
      )}
      <div className={styles.categoriesContainer}>
        {categoriesToRender.map(cat => (
          <DocumentCategoryItem 
            key={cat.id} 
            category={cat} 
            stats={cat.stats}
            getSubcategoriesForCategory={propGetSubcategoriesForCategory}
            isCompanyMode={isCompanyMode}
          />
        ))}
      </div>
    </div>
  );
});

// Add display name for debugging
DocumentCategoriesList.displayName = 'DocumentCategoriesList';

export default DocumentCategoriesList;
